module.exports = __webpack_public_path__ + "static/img/pet-friendly-black.d1afbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pet-friendly-black.png
// module id = MsBm
// module chunks = 1